export default "__VITE_PUBLIC_ASSET__7faf0a4f__"